<template>
<!--    <router-link :to="{ name: 'Hasher', params: {id: hasher.id } }">{{hasher.hash_name}}</router-link>-->
    <div>{{hasher.hash_name}}</div>

</template>

<script>
  export default {
    name: 'Hasher',
    props: ['hasher', 'edit'],
    beforeMount: function () {
    },
    watch: {
    },
    methods: {
    }
  }
</script>
<style lang="scss" scoped>

    div {
        font-size: 1em;
        width: auto !important;
        padding-top: 0;
        padding-bottom: 0;
        text-align: center;
        position: relative;
        top: 50%;
        margin-top: -1em;
        flex-grow: 1;

    }


</style>
